import { Model as LibXModel } from 'libx'
import { action } from 'mobx'
import { type MutableProps } from '@/infra/type-utils'

/**
 * Returns writable props for the model that are not functions.
 */
export type ModelProps<T> = MutableProps<{
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [K in keyof T as T[K] extends (...args: any[]) => any ? never : K]: T[K]
}>

/**
 * Model base class with better type checking.
 */
export abstract class Model<Self> {
  constructor() {
    this.set = action('set', this.set.bind(this))
  }

  /**
   * Sets `props` on the model.
   *
   * @param props
   */
  set(props: Partial<MutableProps<Self>>): this {
    LibXModel.prototype.set.call(this, props, { stripUndefined: true })
    return this
  }
}
